/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:07/02/2023
 @Time:17:45
 **/
$(function(){
    $(".begro-toggle-group").each(function(element){
        let element$=$(this);
        element$.find("button").on('click',function(event){
            let parent$=$(this).parents(".begro-toggle-group");
            let checkbox$=parent$.find("input");
            parent$.toggleClass('on');
            checkbox$.prop("checked",parent$.hasClass("on"));
            checkbox$.trigger('change');
      })
    });
});